export const AUTOCOMPLETE_MODE_DISABLE = 'disable';
